var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargeSconn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "#939CF5",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.835 13.1473C10.62 13.1473 11.6805 12.0658 11.6805 10.7953C11.6805 9.68225 11.061 9.07325 10.1265 8.68475L9.108 8.26475C8.4465 8.00225 7.89 7.79225 7.89 7.23575C7.89 6.73175 8.3205 6.42725 9.003 6.42725C9.6435 6.42725 10.158 6.65825 10.662 7.06775L11.439 6.09125C10.809 5.45075 9.906 5.09375 9.003 5.09375C7.4385 5.09375 6.315 6.07025 6.315 7.34075C6.315 8.46425 7.113 9.10475 7.89 9.41975L8.9295 9.86075C9.6225 10.1547 10.095 10.3438 10.095 10.9212C10.095 11.4567 9.675 11.8032 8.8665 11.8032C8.184 11.8032 7.4385 11.4673 6.8925 10.9528L6 12.0238C6.756 12.7483 7.785 13.1473 8.835 13.1473Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeSconn);
export default __webpack_public_path__ + "static/media/ChargeSconn.1dd2129bfe83024001219c14ecf1d416.svg";
export { ForwardRef as ReactComponent };